<template>
    <div class="container mt-5 pt-5" style="width: 500px;">
        <div class="h1 text-center"><strong>會員資料</strong></div>
        <br>
        <table class="table" style="text-align: center;">
            <tbody>
                <tr>
                    <th scope="row">塔位：</th>
                    <td>{{ userData.niche_id }}</td>
                </tr>
                <tr>
                    <th scope="row">ID：</th>
                    <td>{{ userData.user_id }}</td>
                </tr>
                <tr>
                    <th scope="row">姓名：</th>
                    <td>{{ userData.name }}</td>
                </tr>
                <tr>
                    <th scope="row">帳號：</th>
                    <td>{{ userData.account }}</td>
                </tr>
                <tr>
                    <th scope="row">暱稱：</th>
                    <td>{{ userData.nickname }}</td>
                </tr>
                <tr>
                    <th scope="row">身分證：</th>
                    <td>{{ userData.identity_card_number }}</td>
                </tr>
                <tr>
                    <th scope="row">性別：</th>
                    <td>{{ userData.gender }}</td>
                </tr>
                <tr>
                    <th scope="row">身分：</th>
                    <td>{{ userData.role }}</td>
                </tr>
                <tr>
                    <th scope="row">狀態：</th>
                    <td>{{ userData.status }}</td>
                </tr>
                <tr>
                    <th scope="row">電子郵件：</th>
                    <td>{{ userData.email }}</td>
                </tr>
                <tr>
                    <th scope="row">建立時間：</th>
                    <td>{{ userData.created_at }}</td>
                </tr>
                <tr>
                    <th scope="row">最後編輯時間：</th>
                    <td>{{ userData.updated_at }}</td>
                </tr>
                <tr>
                    <th scope="row">啟用時間：</th>
                    <td>{{ userData.enabled_at }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    props: {
        text: {
            default: 0,
        },
    },
    data() {
        return {
            base_url,
            userData: '0',
        };
    },
    methods: {
        getusers: function () {
            axios
                .get(base_url + "/api/user/" + this.text)
                .then((response) => {
                    this.userData = response.data;
                    console.log(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    created() {
        this.getusers();
    },
}
</script>

<style scoped>
.homebtn {
    border: solid;
    padding: 10px;
}

.alert-success {
    background-color: #FFEEE8 !important;
    font-weight: bold;
    font-size: 18px;
    color: #666666;
}
</style>>
